import { useAuth0 } from '@brighte/passwordless-authenticator';
import { Pages } from '@pages/index';
import { createRootRouteWithContext } from '@tanstack/react-router';

export type Auth0Context = ReturnType<typeof useAuth0>;

type RouterContext = {
  authentication: Auth0Context;
};

export const Route = createRootRouteWithContext<RouterContext>()({
  component: Pages,
  head: () => ({
    meta: [
      {
        title: 'Review Brighte Package',
      },
    ],
  }),
});
